/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";
import { ExclamationIcon } from "@heroicons/react/solid";

/**
 * The Alert component
 *
 * @author Thais Watanabe
 */
const Alert = (props) => {
  var alertStyle = "";
  if (props.type === "danger") {
    alertStyle = "red";
  } else if (props.type === "info") {
    alertStyle = "blue";
  } else {
    alertStyle = "green";
  }
  return (
    <div className={`rounded-md bg-${alertStyle}-50 p-4`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationIcon
            className={`h-5 w-5 text-${alertStyle}-400`}
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium text-${alertStyle}-800`}>
            {props.order}
          </h3>
          {/* <div className={`mt-2 text-sm text-${alertStyle}-700`}>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
              pariatur, ipsum similique veniam quo totam eius aperiam dolorum.
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Alert;
